import * as yup from 'yup';

export const EditCreditBalanceSchema = yup.object({
    balance: yup.number().required('Errors.required').min(0, 'Errors.must_be_positive'),
    creditsPerInterval: yup.number().required('Errors.required').min(0, 'Errors.must_be_positive'),
});
